import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { VIEWS_CONFIG } from './content-splitter.data';

@Component({
  selector: 'app-content-splitter',
  templateUrl: './content-splitter.component.html',
  styleUrls: ['./content-splitter.component.scss'],
})
export class ContentSplitterComponent implements OnChanges {
  @Input() set view(value: number) {
    this.selectedView =
      this._views.find((view) => view.name === value) || this._views[0];
  }

  @Input() order = [0, 1, 2, 3];

  @Output() viewChange = new EventEmitter<number>();

  private _views = VIEWS_CONFIG;

  public selectedView = this._views[0];

  constructor(private _element: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['view']) {
      this._changeView();
    }

    if (changes['order']) {
      this._sortElems();
    }

    this.viewChange.next(this.selectedView.name);
  }

  private _changeView(): void {
    const count = this.selectedView.name;
    const children: HTMLElement[] =
      this._element.nativeElement.children[0]!.children;

    Array.from(children).forEach((child) => (child.hidden = false));
    for (let i = children.length; i > count; i--) {
      children[i - 1].hidden = true;
    }
  }

  private _sortElems(): void {
    const element: HTMLElement = this._element.nativeElement.children[0];
    const hiddenElemIndex = Array.from(element.children).findIndex(
      (x) => (x as HTMLElement).hidden
    );

    this.order.forEach((x, i) => {
      const child = element.children[i] as HTMLElement;
      if (child) {
        child.dataset.index = x.toString();
        child.hidden = false;
      }
    });

    Array.from(element.children)
      .sort((a, b) => {
        const aIndex = +(a as HTMLElement).dataset.index!;
        const bIndex = +(b as HTMLElement).dataset.index!;
        return aIndex < bIndex ? -1 : aIndex > bIndex ? 1 : 0;
      })
      .forEach((item, i) => {
        if (hiddenElemIndex > -1 && i >= hiddenElemIndex) {
          (item as HTMLElement).hidden = true;
        }
        element.appendChild(item);
      });
  }
}
